import {
  SET_TABLE_CHECKED_ITEMS, SET_TABLE_FILTERED_DATA,
  TABLE_CLEAR_DATA,
  TABLE_CLICKED_ROW,
  TABLE_LOAD_DATA,
  TABLE_LOAD_DATA_FAILURE,
  TABLE_LOAD_DATA_SUCCESS,
  TABLE_TOGGLE_ALL,
  TABLE_TOGGLE_SELECTION,
  CLEAR_TABLE_CHECKED_ITEMS,
} from '../actions/types/ListTableActionTypes';
import { AUTH_LOGOUT } from '../../redux/actions/types/authActionTypes';
import { IMPC_EDIT_SUCCESS } from '../../../application/impc-edit/redux/actions/types/ImpcEditActionTypes';
import { BOH_THRESHOLDS_EDIT_SUCCESS } from '../../../application/impc-stock-levels/impc-characteristics/boh-thresholds/edit/redux/actions/types/BalanceOnHandThresholdsEditActionsTypes';
import { SET_ASSET_TYPE } from '../../asset-types/redux/actions/types/AssetTypesActionTypes';

const tableInitialState = {
  isLoading: false,
  mainTableId: null,
  data: [],
  selectedRows: [],
  selection: [],
  selectAll: false,
  filteredData: [],
};

const tablesInitialState = {
  USER_LIST_PAGE: tableInitialState,
  IMPC_DETAILS_PAGE: tableInitialState,
  YEARLY_THRESHOLDS_PAGE: tableInitialState,
  ROUTE_MANAGEMENT_PAGE: tableInitialState,
  IMPC_STOCK_LEVELS_ALL_LIST: tableInitialState,
  IMPC_STOCK_LEVELS_WITH_ALERTS_LIST: tableInitialState,
  IMPC_STOCK_LEVELS_WITH_CENTRAL_ENTRY_POINT: tableInitialState,
  INTERNAL_REPATRIATIONS_TRANSACTIONS: tableInitialState,
  CENTER_INITIATED_REPATRIATIONS: tableInitialState,
  MANUAL_PREADVICE_TRANSACTIONS: tableInitialState,
  BALANCE_MODIFICATION_TRANSACTIONS: tableInitialState,
  REPATRIATIONS_TRANSACTIONS_HISTORY: tableInitialState,
  BALANCE_ON_HAND_TRANSACTIONS_HISTORY: tableInitialState,
  PREADVICE_TRANSACTIONS_HISTORY: tableInitialState,
  VIEW_BOH_CURRENT_INFO: tableInitialState,
  BALANCE_ON_HAND_THRESHOLDS_PAGE: tableInitialState,
  VIEW_BOH_EXPECTED_INFO: tableInitialState,
  VIEW_BOH_ROUTE_INFO: tableInitialState,
  VIEW_BOH_PAST_INFO: tableInitialState,
  PREDES_TRANSACTIONS: tableInitialState,
  ROUTE_MODIFICATION_TRANSACTIONS: tableInitialState,
  ROUTE_MODIFICATION_TRANSACTIONS_HISTORY: tableInitialState,
  PREDES_TRANSACTIONS_HISTORY: tableInitialState,
  REPORTING_BALANCE_ON_HAND_PAGE: tableInitialState,
  MEMBER_POOL_STORAGE_PAGE: tableInitialState,
  REPORTING_FLUX_VOLUME_OE: tableInitialState,
  REPORTING_FLUX_VOLUME_OPERATOR: tableInitialState,
  REPORTING_INTERNAL_REPATRIATIONS: tableInitialState,
  REPORTING_CENTER_INITIATED_REPATRIATIONS: tableInitialState,
  REPORTING_TOTAL_POOL_BREAKDOWN: tableInitialState,
  REPORTING_RFID_MOVEMENT_COUNT: tableInitialState,
  REPORTING_RFID_ON_ROUTE: tableInitialState,
  TRANSACTION_MANAGEMENT: tableInitialState,
  TRANSACTION_HISTORY: tableInitialState,
  REPORTING_RFID_ON_ROUTE_NON_CONSOLIDATED: tableInitialState,
  EDI_RFID_AUDIT_REQUESTS_LIST_PAGE: tableInitialState,
  EDI_RFID_AUDIT_REQUEST_EXECUTIONS: tableInitialState,
  RFID_UPLOADED_FILES_LIST: tableInitialState,
  RFID_FILES_ERRORS_LIST: tableInitialState,
  DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE: tableInitialState,
  DAILY_ROUTE_LEADING_COUNT_SUMMARY: tableInitialState,
  EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT: tableInitialState,
  RECALCULATE_TASKS_LIST: tableInitialState,
};

export default (state = tablesInitialState, action) => {
  switch (action.type) {
    case SET_ASSET_TYPE:
      return tablesInitialState;
    case TABLE_TOGGLE_ALL: {
      const {
        selectAll,
        selection,
        selectedRows,
        tableDefinition,
      } = action.payload;

      return {
        ...state,
        [tableDefinition.id]: {
          ...tableInitialState,
          ...state[tableDefinition.id],
          selectAll,
          selection,
          selectedRows,
        },
      };
    }
    case TABLE_TOGGLE_SELECTION: {
      const { selection, selectedRows, tableDefinition } = action.payload;

      return {
        ...state,
        [tableDefinition.id]: {
          ...tableInitialState,
          ...state[tableDefinition.id],
          selection,
          selectedRows,
          selectAll: state[tableDefinition.id].data.length === selection.length,
        },
      };
    }
  case CLEAR_TABLE_CHECKED_ITEMS: {
    const { tableDefinition } = action.payload;

    return {
      ...state,
      [tableDefinition.id]: {
        ...tableInitialState,
        ...state[tableDefinition.id],
        selection: [],
        selectedRows: [],
        selectAll: false,
      },
    };
  }
    case TABLE_LOAD_DATA: {
      const { tableDefinition, appContext } = action.payload;

      return {
        ...state,
        appContext,
        [tableDefinition.id]: {
          ...tableInitialState,
          ...state[tableDefinition.id],
          selectedRows: [],
          selection: [],
          selectAll: false,
          isLoading: true,
        },
      };
    }
    case TABLE_LOAD_DATA_SUCCESS: {
      const {
        tableDefinition,
        mainTableId,
        data,
        selectedRows,
      } = action.payload;

      return {
        ...state,
        [tableDefinition.id]: {
          ...tableInitialState,
          ...state[tableDefinition.id],
          mainTableId,
          isLoading: false,
          data: tableDefinition.dataTransformer(data),
        },
      };
    }
    case TABLE_LOAD_DATA_FAILURE:
      return {
        ...state,
        [action.payload.tableDefinition.id]: {
          ...tableInitialState,
          mainTableId: action.payload.mainTableId,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case TABLE_CLEAR_DATA:
      return action.payload.tableDefinition && action.payload.tableDefinition.id ? {
        ...state,
        [action.payload.tableDefinition.id]: {
          ...tableInitialState,
          isLoading: true,
        },
      } : tablesInitialState;
    case SET_TABLE_CHECKED_ITEMS: {
      const {
        listId,
        selectedRows,
      } = action.payload;
      return {
        ...state,
        [listId.id]: {
          ...tableInitialState,
          ...state[listId.id],
          checboxSelections: selectedRows,
        },
      };
    }
  case SET_TABLE_FILTERED_DATA: {
    const {
      listId,
      visibleData,
    } = action.payload;
    return {
      ...state,
      [listId.id]: {
        ...tableInitialState,
        ...state[listId.id],
        filteredData: visibleData,
      },
    };
  }
    case TABLE_CLICKED_ROW:
      return {
        ...state,
        clickedRow: { ...action.clickedRow },
      };
    case BOH_THRESHOLDS_EDIT_SUCCESS: {
      const { BALANCE_ON_HAND_THRESHOLDS_PAGE: { data } } = state;
      const { id, 0: rest } = action.payload;

      const i = data.findIndex((d) => d.id === id);

      return {
        ...state,
        BALANCE_ON_HAND_THRESHOLDS_PAGE: {
          ...state.BALANCE_ON_HAND_THRESHOLDS_PAGE,
          data: [
            ...data.slice(0, i),
            { id, ...rest },
            ...data.slice(i + 1),
          ],
        },
      };
    }
    case IMPC_EDIT_SUCCESS: {
      const { IMPC_DETAILS_PAGE: { data } } = state;
      const { id, ...rest } = action.payload;

      const i = data.findIndex((d) => d.id === id);

      return {
        ...state,
        IMPC_DETAILS_PAGE: {
          ...state.IMPC_DETAILS_PAGE,
          data: [
            ...data.slice(0, i),
            { id, ...rest },
            ...data.slice(i + 1),
          ],
        },
      };
    }
    case AUTH_LOGOUT:
      return tablesInitialState;
    default:
      return state;
  }
};
